import video from '../videos/bgVideo.mp4';

const Background = () => {
  return (
    <>
      <video autoPlay={true} muted={true} loop={true}
        className="
          object-cover
          h-full
          w-full
          fixed"
        style={{
          zIndex: '-2'
        }}
        >
        <source src={ video } type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="w-full min-h-screen fixed bg-black bg-opacity-30" style={{ zIndex: '-1'}}></div>
    </>
  )
}

export default Background